import React from "react";
import Helmet from "react-helmet";
import PDF from "../../common/PDF";
import { useLive } from "../LiveProvider";
import LiveHeader from "../common/LiveHeader";
import {
  Container,
  InnerContainer,
  Wrapper,
  IFrame
} from "./styled/live-guidance-details";

function LiveGuidanceDetails({ pageKey }) {
  const { agent, getModuleData } = useLive();
  const page = getModuleData(pageKey);
  const title = pageKey === "agent_resume" ? agent.name : page.title;
  const isFullPage = Boolean(page.url || page.isPdf);

  return (
    <Container id="live" isFullPage={isFullPage} className="guidance-container">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <LiveHeader>{title}</LiveHeader>
      <InnerContainer
        isFullPage={isFullPage}
        className="guidance-inner-container">
        {!isFullPage && (
          <Wrapper isFullPage={isFullPage} className="guidance-wrapper">
            <div
              dangerouslySetInnerHTML={{ __html: page.content || "No Content" }}
            />
          </Wrapper>
        )}
        {isFullPage && (
          <>
            {!page.isPdf && <IFrame src={page.url} />}
            {page.isPdf && <PDF url={page.url} />}
          </>
        )}
      </InnerContainer>
    </Container>
  );
}

export default LiveGuidanceDetails;
